import { render, staticRenderFns } from "./ImageEmptyLayout.vue?vue&type=template&id=95ba0a0a&scoped=true&"
import script from "./ImageEmptyLayout.vue?vue&type=script&lang=js&"
export * from "./ImageEmptyLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ba0a0a",
  null
  
)

export default component.exports